import React, { useEffect, useRef, useState } from "react";
import { useWorkStateFields } from '../../store/hooks';
import { Link } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCopy,
  faXmark,
  faCircleCheck,
  faPenToSquare,
  faArrowLeft,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

import Popup from "../../components/Popup/Popup.js";

import downloadIcon from "../../images/download.png";
import lockIcon from "../../images/lock.png";
import deleteIcon from "../../images/delete.png";
import imageIcon from "../../images/camera.png";
import videoIcon from "../../images/video.png";
import albumIcon from "../../images/drawing-book.png";
import libraryIcon from "../../images/libraryIcon.png";

import {
  get_platform_bg_color,
  get_platform_action_color,
  getWhatsappShareUrl,
  checkPlurality,
  isAdmin,
  getShareTab,
  getUnhiddenShareTab,
  downloadVideo,
  downloadQRCode,
  copyLinkUrl,
  globalLoader,
} from "../../script/util";
import { openExternalApp } from '@egreact/shared';
import { get_global_can_add_to, get_selected_workId, get_can_edit_draft_album } from "./work_utils.js";
import { download, deleteUploads, photos, videos, albums, userFolders, guestUpload, addTo, flagPhotos } from "../../context/workConstants";
import { faCircleCheck as hollowCheck } from "@fortawesome/free-regular-svg-icons";

const WorkDetailPopup = (props) => {
  const queryParams = new URLSearchParams(window.location.search);
  const tab = queryParams.get("tab");
  const showTrash = queryParams.get("trash");

  const [nicknameInputValue, setNicknameInputValue] = useState("");
  const [isEditingNickname, setIsEditingNickname] = useState(false);
  const [folderNameInputValue, setFolderNameInputValue] = useState("");
  const [shareNote, setShareNote] = useState("");
  const [loading ,setLoading] = useState(false)
  const [showPrintAlbumTip, setShowPrintAlbumTip] = useState(false)

  const {
    currentDimensions, isPopupOpen, setIsPopupOpen, downloadDetails, lockPopup,
    setLockPopup, collection, isAddToOpen, setIsAddToOpen, popupRef, faceSearchOn,
    collectionData, faceSearchData, printSelection, albumBookingData, printSelectedData,
    libraryData, checkedFolder, setCheckedFolder, newFolderPopup, setNewFolderPopup,
    folderName, setFolderName, galleryNextCollectionPopup, setGalleryNextCollectionPopup,
    galleryCollectionName, galleryRightArrow, shareLinkPopup, setShareLinkPopup,
    shareLinkData, qrRef, nickname, nicknameInput, setNickname, downloadPopup,
    setDownloadPopup, deleteType, setDeleteType, folderDeletePopup, setFolderDeletePopup,
    qualityVideo, setQualityVideo, videoDetails, currentQuality, currentQualityUrl,
    setCurrentQualityUrl, setCurrentQuality, albumBookingPopup, setAlbumBookingPopup,
    uploadExpiryOpen, setUploadExpiryOpen, expiryDate, flagPhotoPopup, setFlagPhotoPopup,
    currentPhotoFlagged, galleryImages, photoIndex, shareSelective, setShareSelective,
    shareTab, setShareTab, shareSelectList, setShareSelectList, hiddenWork, data,
    setPrintSelection, setPrintSelectedData, setSelectionType, faceFormattedData,
    collectionFormattedData, flaggedData, setMultipleSelect, setUpdateSinglePhoto,
    selection, setSelection, setSelectImages, setHideSelection, setDownloadSelection,
    setDeleteSelection, setApproveFlagSelection, setAddToSelection, setSelectionAll,
    setFaceSelect, setFaceHide, faceHide, hideSelectedObj, setImages, setSelectedImages,
    setShowToast, setToastMessage, deletePopup, setDeletePopup, trashDeletePopup,
    setTrashDeletePopup, trashFoldersInfo, allTrashDeletePopup, setAllTrashDeletePopup,
    setDeleteConfirm,
  } = useWorkStateFields(['currentDimensions', 'isPopupOpen', 'downloadDetails', 'lockPopup', 'collection', 'isAddToOpen', 'faceSearchOn', 'collectionData', 'faceSearchData', 'printSelection', 'albumBookingData', 'printSelectedData', 'libraryData', 'checkedFolder', 'newFolderPopup', 'folderName', 'galleryNextCollectionPopup', 'galleryCollectionName', 'galleryRightArrow', 'shareLinkPopup', 'shareLinkData', 'nickname', 'downloadPopup', 'deleteType', 'folderDeletePopup', 'qualityVideo', 'videoDetails', 'currentQuality', 'currentQualityUrl', 'albumBookingPopup', 'uploadExpiryOpen', 'expiryDate', 'flagPhotoPopup', 'currentPhotoFlagged', 'galleryImages', 'photoIndex', 'shareSelective', 'shareTab', 'shareSelectList', 'hiddenWork', 'data', 'faceFormattedData', 'collectionFormattedData', 'flaggedData', 'selection', 'faceHide', 'hideSelectedObj', 'deletePopup', 'trashDeletePopup', 'trashFoldersInfo', 'allTrashDeletePopup']);

  // Deliverable admins can view but not edit the draft album. UX gate only.
  const canEditDraftAlbum = get_can_edit_draft_album(collection, data);

   const handleQrDownload = async () => {
    setLoading(true);
    try {
      await downloadQRCode(qrRef, data?.booking_name);
    } catch (error) {
      setLoading(false)
      alert(error);
    } finally {
      setLoading(false);
    }
  };

  const switchShareTabs = (switchTabs) => {
    setShareTab(switchTabs);
  };

  const shareSelectMedia = (type, id) => {
    if (hiddenWork[id]) return;
    const ele = id.toString();
    setShareSelectList((prevState) => {
      const currentArray = prevState[type] || [];
      return {
        ...prevState,
        [type]: currentArray.includes(ele)
          ? currentArray.filter((item) => item !== ele)
          : [...currentArray, ele]
      };
    });
  };

  const shareSelectAllCollection = (type, data) => {
    setShareSelectList((prevState) => {
      const currentSelection = prevState[type] || [];
      if (data.length > 0) {
        const updatedSelection = data.reduce((acc, e) => {
          if (!hiddenWork[e.work_id] && e.is_shareable !== false) {
            let id = e.work_id.toString();
            if (acc.includes(id)) {
              return [...acc];
            } else {
              return [...acc, id];
            }
          } else return [...acc];
        }, currentSelection);

        return { ...prevState, [type]: updatedSelection };
      } else {
        const { [type]: _, ...rest } = prevState;
        return { ...rest, [type]: [] };
      }
    });
  };

  const confirShareLost = () => {
    if (Object.values(shareSelectList).flat().length == 0) {
      setShareSelective(false);
      setShareSelectList({});
    } else {
      const userConfirmed = window.confirm("All selections will be lost!");
      if (userConfirmed && Object.values(shareSelectList).flat().length > 0) {
        setShareSelective(false);
        setShareSelectList({});
      }
    }
  };

  const printBooking = (bookingId, work_id_list) => {
    setAlbumBookingPopup(false);
    getSelectionDataForDownload(addTo);
    setPrintSelection(true);
    setPrintSelectedData({
      booking_id: bookingId,
      work_id_list: work_id_list
    });
  };

  const handleFlagPhotos = (photo_id) => {
    setSelectionType(flagPhotos);
    const selectedData = faceSearchOn ? faceFormattedData : collectionFormattedData;
    const selectedWorkId = get_selected_workId(selectedData, photo_id);
    const inSelect = flaggedData[selectedWorkId]?.includes(photo_id) ? true : false;

    setMultipleSelect((prevMultipleSelect) => {
      const index = prevMultipleSelect.findIndex((obj) => obj.work_id === selectedWorkId);
      if (index === -1) {
        prevMultipleSelect = [
          ...prevMultipleSelect,
          { work_id: selectedWorkId, select_list: [], unselect_list: [] },
        ];
      }

      return prevMultipleSelect.map((item) => {
        if (item.work_id === selectedWorkId) {
          if (!inSelect) {
            return {
              ...item,
              unselect_list: item.unselect_list.filter((e) => e !== photo_id),
              select_list: [...item.select_list, photo_id],
            };
          } else {
            return {
              ...item,
              select_list: item.select_list.filter((e) => e !== photo_id),
              unselect_list: [...item.unselect_list, photo_id],
            };
          }
        }
        return item;
      });
    });

    setUpdateSinglePhoto(true);
  };

  const cancelSelection = () => {
    if (selection) {
      setMultipleSelect((prevSelect) =>
        prevSelect.map((item) => ({
          ...item,
          select_list: [],
          unselect_list: []
        }))
      );
      setSelectImages((prev) => {
        const cleared = {};
        Object.keys(prev).forEach((collectionId) => {
          cleared[collectionId] = {};

          Object.keys(prev[collectionId]).forEach((key) => {
            cleared[collectionId][key] = [];
          });
        });
        return cleared;
      });
    }
    setHideSelection(false);
    setDownloadSelection(false);
    setDeleteSelection(false);
    setApproveFlagSelection(false);
    setAddToSelection(false);
    setSelection(false);
    setDeletePopup(false);
    setPrintSelection(false);
    setSelectionAll({});
    if (faceSearchOn) {
      setFaceSelect(faceHide);
    } else {
      setSelectedImages(hideSelectedObj);
    }
    setImages([]);
    setSelectionType();
  };

  const {
    lockAlbum, addToDone, updateAlbum, updateFolders, addNickname, downloadCollection,
    downloadFaceSearch, getSelectionDataForDownload, getSelectionDataForDelete,
    trashFolder, shareSelection, handleTrashDelete, createNewFolder, handleNextCollection,
    hideSelected
  } = props;

  const isGuestUploadTab = tab === guestUpload;

  const updateShareNote = () => {
    if (!shareLinkPopup || !shareLinkData) {
      setShareNote("");
      return;
    }

    const noteType = shareLinkData.note_type;
    let note = "";

    if (noteType === "all") {
      note = "<div>Note: All new uploaded data will be visible on this link</div>";
    } else if (noteType === "face_only") {
      note = "<div><ul><li>Using this link, guests can click a selfie and only see their photos.</li><li>They will not have access to photos in which they are not present.</li></ul></div>";
    }

    setShareNote(note);
  };

  useEffect(() => {
    if (shareLinkPopup) {
      if (nickname) {
        setNicknameInputValue("");
        setIsEditingNickname(false);
      } else if (shareLinkData?.nickname) {
        setNicknameInputValue(shareLinkData.nickname);
        setIsEditingNickname(true);
      } else {
        setNicknameInputValue("");
        setIsEditingNickname(true);
      }
    } else {
      setNicknameInputValue("");
      setIsEditingNickname(false);
    }
  }, [shareLinkPopup, nickname, shareLinkData?.nickname]);

  useEffect(() => {
    updateShareNote();
  }, [shareLinkPopup, shareLinkData]);

  const initialNickname = (nickname || shareLinkData?.nickname || "").trim();

  useEffect(() => {
    if (newFolderPopup) {
      setFolderNameInputValue(folderName || "");
    } else {
      setFolderNameInputValue("");
    }
  }, [newFolderPopup, folderName]);

  useEffect(() => {
    if (!isAddToOpen) return;
    setShowPrintAlbumTip(true);
    const t = setTimeout(() => setShowPrintAlbumTip(false), 10000);
    return () => clearTimeout(t);
  }, [isAddToOpen]);

  return (
    <>
      {
                        loading && <div className='overlayLoader'  style={{ zIndex: 9999 }}>{globalLoader()}</div>
      }
      {/* ===== Download ZIP popup ===== */}
      {isPopupOpen && (
        <Popup
          isOpen={isPopupOpen}
          onClose={() => {
            setIsPopupOpen(false);
          }}
        >
          <div className="downloadDetails">
            {downloadDetails?.download_title && <h3>{downloadDetails.download_title}</h3>}
            <div
              className="downloadData"
              style={{ display: !downloadDetails?.size_msg && "none" }}
            >
              The size of selected files is approx{" "}
              <span style={{ fontWeight: "900" }}>{downloadDetails?.size_msg}</span>.
            </div>
            <Link
              to={`${downloadDetails?.link}`}
              target="_blank"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <button
                className="shareWp"
                style={{ backgroundColor: get_platform_bg_color(), border: "none" }}
              >
                <img
                  style={{ height: currentDimensions > 600 ? "22px" : "20px" }}
                  src={downloadIcon}
                  className="invert-image"
                  alt="download"
                />
                Download Zip
              </button>
            </Link>
            <div
              className="cpyAlbum"
              style={{ backgroundColor: "rgba(0,0,0,0.7)", margin: "7px auto 14px auto" }}
            >
              <FontAwesomeIcon icon={faCopy} style={{ color: "#ffffff" }} />
              <p onClick={() => copyLinkUrl(downloadDetails?.link, setShowToast, setToastMessage)}>Copy Zip Link</p>
            </div>
            <Link onClick={() => openExternalApp(`${getWhatsappShareUrl(downloadDetails?.link)}`)} target="_blank">
              <button className="shareWp">
                <FontAwesomeIcon
                  icon={faWhatsapp}
                  style={{ color: "#ffffff" }}
                  size="lg"
                />{" "}
                Share Zip Link
              </button>
            </Link>
          </div>
        </Popup>
      )}

      {/* ===== Lock album popup ===== */}
      {lockPopup && (
        <Popup
          isOpen={lockPopup}
          onClose={() => {
            setLockPopup(false);
          }}
        >
          <div style={{ textAlign: "left", padding: "10px", maxWidth: "500px" }}>
            <h3>{collection?.lock_dialog?.title}</h3>
            <div style={{ padding: "10px 0" }}>{collection?.lock_dialog?.message}</div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                fontSize: "medium",
              }}
            >
              <button
                style={{
                  border: "1px solid black",
                  padding: "3px 5px",
                  borderRadius: "10px",
                }}
                onClick={() => setLockPopup(false)}
              >
                Cancel
              </button>
              <button
                style={{
                  border: `1px solid ${get_platform_action_color()}`,
                  color: "white",
                  background: get_platform_action_color(),
                  padding: "3px 5px",
                  borderRadius: "10px",
                  display: "flex",
                  margin: "0 10px",
                  alignItems: "center",
                }}
                onClick={() => {
                  setLockPopup(false);
                  lockAlbum();
                }}
              >
                <img
                  className="invert-image"
                  style={{
                    width: "18px",
                    marginRight: "4px",
                    minWidth: "18px",
                    height: "18px",
                  }}
                  src={lockIcon}
                  alt="lock"
                />{" "}
                Lock
              </button>
            </div>
          </div>
        </Popup>
      )}

      {/* ===== Add-To popup ===== */}
      {isAddToOpen && (
        <Popup
          isOpen={isAddToOpen}
          onClose={() => {
            setIsAddToOpen(false);
            setCheckedFolder([]);
          }}
        >
          <div
            ref={popupRef}
            style={{
              minWidth: currentDimensions > 600 ? "35vw" : "80vw",
              maxWidth: currentDimensions > 600 ? "35vw" : "80vw",
              margin: currentDimensions > 600 && "20px",
              textAlign: "center",
              color: "black",
              maxHeight: "400px",
              overflowY: "auto",
            }}
            className="addToMainDiv"
          >
            <h3 style={{ margin: "0 0 10px" }}>Add to</h3>

            {(faceSearchOn
              ? collection && collection.album_data && collection.album_data.album_data
              : (tab === "userfolders" ? printSelection : collection)) && (
              <>
                <div style={{ textAlign: "left" }}>
                  <div className="tooltip" style={{ display: "inline-flex", alignItems: "center" }}>
                    <h4 style={{ fontWeight: "bold" }}>Print Albums</h4>
                    <span className={`printAlbumTip ${showPrintAlbumTip ? 'show' : ''}`}>Add Photos here to get them printed</span>
                  </div>
                </div>
                <ul style={{ listStyle: "none", padding: 0, marginRight: "10px" }}>
                  {((printSelection && tab === "userfolders")
                    ? albumBookingData?.[printSelectedData?.booking_id]?.albums
                    : (faceSearchOn ? faceSearchData : collection)?.album_data?.album_data) &&
                    Object.entries(
                      (printSelection && tab === "userfolders")
                        ? albumBookingData?.[printSelectedData?.booking_id]?.albums
                        : (faceSearchOn ? faceSearchData : collection).album_data.album_data
                    ).map(([albumKey, myAlbumData]) => (
                      <li
                        key={albumKey}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "10px 2px",
                          borderBottom: "1px solid #ddd",
                          cursor: "pointer",
                        }}
                      >
                        <a
                          href={`${myAlbumData.album_url}`}
                          target="_blank"
                          rel="noreferrer"
                          size="xs"
                          style={{ marginRight: "10px" }}
                        >
                          <img
                            src={myAlbumData?.cover_image}
                            style={{
                              minWidth: "50px",
                              height: "35px",
                              border: `1px solid ${get_platform_bg_color()}`,
                              borderRadius: "5px",
                              objectFit: "cover",
                              objectPosition: "top",
                            }}
                            alt="album-cover"
                          />
                        </a>
                        <label
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                            cursor: "pointer",
                            marginLeft: "5px",
                          }}
                        >
                          <span
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "flex-start",
                              gap: "0.1rem",
                              lineHeight: "1.3",
                            }}
                          >
                            {myAlbumData.title}{" "}
                            <span
                              style={{
                                fontSize: "0.8rem",
                                fontWeight: "normal",
                                whiteSpace: "nowrap",
                              }}
                            >
                              ({myAlbumData.album_photo_count} photos added)
                            </span>
                          </span>
                          {myAlbumData && !myAlbumData?.is_locked ? (
                            <input
                              type="checkbox"
                              style={{
                                cursor: "pointer",
                                accentColor: get_platform_bg_color(),
                              }}
                              onChange={(event) => {
                                const checked = event.target.checked;
                                updateAlbum(albumKey, checked);
                              }}
                              disabled={(myAlbumData && myAlbumData?.is_locked) || !canEditDraftAlbum || isAdmin()}
                            />
                          ) : (
                            <span
                              style={{
                                fontStyle: "italic",
                                color: "gray",
                                fontSize: "medium",
                              }}
                            >
                              Locked
                            </span>
                          )}
                        </label>
                      </li>
                    ))}
                </ul>
              </>
            )}

            {/* Library */}
            {get_global_can_add_to(faceSearchOn ? faceSearchData : collection) &&
              !printSelection && (
                <>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      paddingTop: "10px",
                      marginRight: "10px",
                    }}
                  >
                    <h4 style={{ fontWeight: "bold" }}>My Collections</h4>
                    <h4
                      style={{
                        color: "#3EA6FF",
                        cursor: "pointer",
                        fontWeight: "900",
                      }}
                      onClick={() => {
                        setNewFolderPopup(true);
                      }}
                    >
                      <FontAwesomeIcon icon={faPenToSquare} style={{ color: "#3EA6FF" }} /> New
                    </h4>
                  </div>
                  <ul style={{ listStyle: "none", padding: 0, marginRight: "10px" }}>
                    {libraryData?.data?.hasOwnProperty("folders") &&
                    libraryData?.data?.folders?.length > 0 ? (
                      libraryData?.data?.folders?.map((folder) => (
                        <li
                          key={folder.work_id}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "10px 2px",
                            borderBottom: "1px solid #ddd",
                            cursor: "pointer",
                          }}
                        >
                          <a
                            href={`${folder?.folder_url}`}
                            target="_blank"
                            rel="noreferrer"
                            size="xs"
                            style={{ marginRight: "10px" }}
                          >
                            <img
                              src={folder?.cover_image}
                              style={{
                                minWidth: "50px",
                                height: "35px",
                                border: `1px solid ${get_platform_bg_color()}`,
                                borderRadius: "5px",
                                objectFit: "cover",
                                objectPosition: "top",
                              }}
                              alt="folder-cover"
                            />
                          </a>
                          <label
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              width: "100%",
                              cursor: "pointer",
                              marginLeft: "5px",
                            }}
                          >
                            <span
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                gap: "0.1rem",
                                lineHeight: "1.3",
                              }}
                            >
                              {folder?.title}{" "}
                              <span
                                style={{
                                  fontSize: "0.8rem",
                                  fontWeight: "normal",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                ({folder?.total_count} photos added)
                              </span>
                            </span>
                            <input
                              type="checkbox"
                              style={{
                                cursor: "pointer",
                                accentColor: get_platform_bg_color(),
                              }}
                              checked={checkedFolder[folder.work_id] || false}
                              onChange={(event) => {
                                const checked = event.target.checked;
                                setCheckedFolder((prev) => ({
                                  ...prev,
                                  [folder.work_id]: checked,
                                }));
                                updateFolders(folder.work_id, checked);
                              }}
                              disabled={isAdmin()}
                            />
                          </label>
                        </li>
                      ))
                    ) : (
                      <div
                        style={{
                          fontWeight: "600",
                          fontStyle: "italic",
                          color: "grey",
                        }}
                      >
                        No Collections!
                      </div>
                    )}
                  </ul>
                </>
              )}
          </div>
          <button
            style={{
              marginRight: "2vw",
              padding: "5px 8px",
              backgroundColor: get_platform_action_color(),
              border: "none",
              borderRadius: "5px",
              color: "white",
              cursor: "pointer",
            }}
            onClick={addToDone}
          >
            Done
          </button>
        </Popup>
      )}

      {/* ===== New folder popup ===== */}
      {newFolderPopup && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 2000 }}>
          <div style={{ background: 'white', padding: '10px 20px 30px 20px', borderRadius: '8px', textAlign: 'right', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)', position: 'relative' }}>
            <button 
              style={{ position: 'absolute', top: '10px', right: '10px', background: 'none', border: 'none', cursor: 'pointer', color: 'black' }}
              onClick={() => {
                setNewFolderPopup(false);
                setFolderName("");
              }}
            >
              <FontAwesomeIcon size='xl' icon={faXmark} />
            </button>
          <h4 style={{ textAlign: "center", padding: "10px" }}>Create New Folder</h4>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "250px",
            }}
          >
            <input
              type="text"
              className="form-input"
              style={{
                width: "inherit",
                background: "whitesmoke",
                padding: "7px 9px",
                border: "2px solid #EEEEEE",
                borderRadius: "5px",
                fontStyle: "italic",
              }}
              autoFocus={true}
              maxLength={25}
              placeholder="e.g: Friends"
              value={folderNameInputValue}
              onChange={(e) => {
                const value = e.target.value;
                setFolderNameInputValue(value);
                setFolderName(value);
              }}
            />
            <div style={{ marginTop: "10px", width: "inherit" }}>
              <button
                style={{
                  padding: "5px 8px",
                  borderRadius: "5px",
                  border: `1px solid ${get_platform_bg_color()}`,
                  marginRight: "10px",
                }}
                onClick={() => {
                  setNewFolderPopup(false);
                  setFolderName("");
                }}
              >
                <span>Cancel</span>
              </button>
              <button
                id="new-folder-save-btn"
                disabled={!folderNameInputValue || folderNameInputValue.trim() === ""}
                style={{
                  color: "white",
                  background: get_platform_bg_color(),
                  padding: "5px 8px",
                  borderRadius: "5px",
                  border: `1px solid ${get_platform_bg_color()}`,
                  cursor: (!folderNameInputValue || folderNameInputValue.trim() === "") ? "not-allowed" : "pointer",
                  opacity: (!folderNameInputValue || folderNameInputValue.trim() === "") ? "0.5" : "1",
                }}
                onClick={() => {createNewFolder(); setFolderName("");}}
              >
                <span>Create</span>
              </button>
            </div>
          </div>
          </div>
        </div>
      )}

      {/* ===== Gallery "Move to" popup ===== */}
      {galleryNextCollectionPopup && (
        <Popup
          isOpen={galleryNextCollectionPopup}
          onClose={() => setGalleryNextCollectionPopup(false)}
        >
          <div style={{ padding: "0 20px" }}>
            <div style={{ padding: "8px 2px", textAlign: "center" }}>Move to</div>
            <div
              className="galleryCollectionButton"
              style={{
                backgroundColor: get_platform_bg_color(),
                border: `1px solid ${get_platform_bg_color()}`,
                cursor: "pointer",
              }}
              onClick={() => {
                handleNextCollection(galleryRightArrow ? true : false, true);
              }}
            >
              {!galleryRightArrow && (
                <FontAwesomeIcon icon={faArrowLeft} style={{ color: "#ffffff" }} size="sm" />
              )}{" "}
              {galleryCollectionName}{" "}
              {galleryRightArrow && (
                <FontAwesomeIcon icon={faArrowRight} style={{ color: "#ffffff" }} size="sm" />
              )}
            </div>
          </div>
        </Popup>
      )}
      {/* ===== Share link popup (guest uploads) ===== */}
      {shareLinkPopup && (
        <div className="guestuploads-share-popup">
          <Popup
            isOpen={true}
            onClose={() => {
              setShareLinkPopup(false);
              setNickname("");
            }}
          >
            <div className="popupWidth">
              <div className="guestuploads-share-popup-title">Share</div>
              <div
                id="shareNote"
                dangerouslySetInnerHTML={shareNote ? { __html: shareNote } : undefined}
              ></div>

              {shareLinkData?.share_url && tab === guestUpload && (
                <div className="qr-wrapper">
                  <div ref={qrRef} className="qr-canvas">
                    <QRCodeCanvas value={shareLinkData.share_url} size={180} 
                    bgColor="transparent"
                    fgColor="#000000"
                    />
                  </div>
                  <button
                    className="qr-download-btn"
                    style={{ backgroundColor: get_platform_bg_color() }}
                    onClick={handleQrDownload}
                  >
                    <span>Download QR Code</span>
                  </button>
                </div>
              )}

              <div className="guestuploads-share-actions">
                <div
                  className="copy-link-btn"
                  onClick={() => copyLinkUrl(shareLinkData?.share_url, setShowToast, setToastMessage)}
                >
                  <FontAwesomeIcon icon={faCopy} />
                  Copy Link
                </div>

                <Link
                  onClick={() => openExternalApp(`${getWhatsappShareUrl(shareLinkData?.share_msg)}`)}
                  target="_blank"
                  style={{ textDecoration: "none" }}
                >
                  <button className="whatsapp-share-btn">
                    <FontAwesomeIcon icon={faWhatsapp} />
                    Share
                  </button>
                </Link>
              </div>

            <div className="nickname-input-wrapper">

              {(!nickname || isEditingNickname) && (<>
                <div className="nickname-prompt">Add a link title:</div>
                <div className="nickname-input-row">
                  <input
                    type="text"
                    className="nickname-input form-input"
                    maxLength={25}
                    placeholder="e.g: DJ Night"
                    value={nicknameInputValue}
                    onChange={(e) => setNicknameInputValue(e.target.value)}
                  />

                  {(() => {
                    const trimmedValue = nicknameInputValue.trim();
                    const isSaveDisabled =
                      trimmedValue === "" || trimmedValue === initialNickname;

                    return (
                  <button
                    className="nickname-save-btn"
                    disabled={isSaveDisabled}
                    style={{
                      background: get_platform_bg_color(),
                      borderColor: get_platform_bg_color(),
                      cursor:
                        isSaveDisabled ? "not-allowed" : "pointer",
                      opacity: isSaveDisabled ? 0.5 : 1,
                    }}
                    onClick={() => {
                      addNickname(nicknameInputValue.trim());
                      setNicknameInputValue("");
                      setIsEditingNickname(false);
                    }}
                  >
                    Save
                  </button>
                    );
                  })()}
                </div>
                </>
              )}

              {nickname && !isEditingNickname && (
                <div className="nickname-display">
                  {nickname}
                  <FontAwesomeIcon
                    icon={faPenToSquare}
                    size="sm"
                    style={{ marginLeft: 6, cursor: "pointer" }}
                    onClick={() => {
                      setNicknameInputValue(nickname);
                      setIsEditingNickname(true);
                    }}
                  />
                </div>
              )}
            </div>

            </div>
          </Popup>
        </div>
      )}

      {/* ===== Download method popup ===== */}
      {downloadPopup && (
        <Popup
          isOpen={true}
          onClose={() => {
            setDownloadPopup(false);
          }}
        >
          <div style={{ textAlign: "center", fontWeight: "900", fontSize: "25px", minWidth: "20vw" }}>
            Download
          </div>
          <div
            style={{ justifyItems: "center", width: "100%", display: "grid" }}
            onClick={() => {
              setDownloadPopup(false);
              getSelectionDataForDownload(download);
            }}
          >
            <button
              style={{ background: get_platform_bg_color() }}
              className="downMethod"
            >
              <FontAwesomeIcon
                icon={hollowCheck}
                style={{ paddingRight: "5px", color: "#ffffff" }}
              />
              <p>Selectively</p>
            </button>
          </div>
          <div
            style={{ justifyItems: "center", width: "100%", display: "grid" }}
            onClick={() => {
              setDownloadPopup(false);
              if (!faceSearchOn && tab !== "albumselection" && tab !== "userfolders") {
                downloadCollection();
              } else {
                downloadFaceSearch();
              }
            }}
          >
            <button
              style={{ background: get_platform_action_color() }}
              className="downMethod"
            >
              <img
                className="invert-image"
                style={{ height: "20px", paddingRight: "5px" }}
                src={downloadIcon}
                alt="download"
              />
              <p>{(faceSearchOn || isGuestUploadTab) ? <span>All Photos</span> : collection?.title}</p>
            </button>
          </div>
        </Popup>
      )}

      {/* ===== Delete type popup ===== */}
      {deleteType && (
        <Popup
          isOpen={true}
          onClose={() => {
            setDeleteType(false);
          }}
        >
          <div style={{ textAlign: "center", fontWeight: "900", fontSize: "25px", minWidth: "20vw" }}>
            Delete
          </div>
          <div
            style={{ justifyItems: "center", width: "100%", display: "grid" }}
            onClick={() => {
              setDeleteType(false);
              getSelectionDataForDelete(deleteUploads);
            }}
          >
            <button
              style={{ background: get_platform_bg_color() }}
              className="downMethod"
            >
              <FontAwesomeIcon
                icon={hollowCheck}
                style={{ paddingRight: "5px", color: "#ffffff" }}
              />
              <p>Selectively</p>
            </button>
          </div>
          <div
            style={{ justifyItems: "center", width: "100%", display: "grid" }}
            onClick={() => {
              setDeleteType(false);
              setFolderDeletePopup(true);
            }}
          >
            <button
              style={{ background: "#952d2d" }}
              className="downMethod"
            >
              <img
                className="invert-image"
                style={{ height: "20px", paddingRight: "5px" }}
                src={deleteIcon}
                alt="delete"
              />
              <p>{(faceSearchOn || isGuestUploadTab) ? <span>All Photos</span> : collection?.title}</p>
            </button>
          </div>
        </Popup>
      )}

      {/* ===== Folder move to trash confirmation ===== */}
      {folderDeletePopup && (
        <Popup isOpen={folderDeletePopup}>
          <div style={{ textAlign: "center", fontWeight: "900", fontSize: "25px", minWidth: "20vw" }}>
            Trash
          </div>
          <div
            style={{
              padding: "10px 0",
              textAlign: "left",
              fontSize: currentDimensions > 600 && "large",
            }}
          >
            {collection?.title || "Library"} will be moved to trash!
          </div>
          <div style={{ textAlign: "right", padding: "7px 0 10px 0" }}>
            <button
              style={{
                padding: "2px 5px",
                borderRadius: "5px",
                border: "1px solid black",
                marginRight: "10px",
              }}
              onClick={() => setFolderDeletePopup(false)}
            >
              Cancel
            </button>
            <button
              style={{
                padding: "2px 5px",
                borderRadius: "5px",
                background: "#952d2d",
                color: "white",
                border: "1px solid #952d2d",
              }}
              onClick={trashFolder}
            >
              Trash
            </button>
          </div>
        </Popup>
      )}

      {/* ===== Video quality popup ===== */}

      {qualityVideo && (
        <Popup
          isOpen={true}
          onClose={() => {
            setQualityVideo(false);
          }}
        >
          <div
            style={{
              margin: "0 20px",
              justifyItems: "center",
              display: "grid",
            }}
          >
            <div
              style={{
                textAlign: "center",
                fontWeight: "600",
                fontSize: "23px",
                padding: "5px",
              }}
            >
              Quality
            </div>

            {(() => {
              const normalizedCurrentQuality = String(currentQuality ?? "");

              return videoDetails?.map((e) => {
                const qualityStr = String(e.quality);
                const isChecked = qualityStr === normalizedCurrentQuality;

                return (
                  <div key={`quality-${qualityStr}`} className="qualityRadio">
                    <label
                      htmlFor={`video-quality-${qualityStr}`}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        minWidth: "170px",
                        cursor: "pointer",
                      }}
                    >
                      <p>{e.name}</p>

                      <input
                        id={`video-quality-${qualityStr}`}
                        type="radio"
                        name="videoQuality"
                        value={qualityStr}
                        checked={isChecked}
                        onChange={() => {
                          setCurrentQuality(qualityStr);
                          setCurrentQualityUrl(e.url);
                        }}
                        style={{
                          accentColor: get_platform_action_color(),
                          cursor: "pointer",
                        }}
                      />
                    </label>
                  </div>
                );
              });
            })()}

            <div
              style={{
                padding: "5px 10px",
                borderRadius: "5px",
                color: "white",
                background: get_platform_action_color(),
                width: "fit-content",
                margin: "5px",
                cursor: "pointer",
              }}
              onClick={() => downloadVideo(currentQualityUrl, setQualityVideo)}
            >
              Download
            </div>
          </div>
        </Popup>
      )}


      {/* ===== Album booking selection popup ===== */}
      {albumBookingPopup && (
        <Popup
          isOpen={albumBookingPopup}
          onClose={() => {
            setAlbumBookingPopup(false);
          }}
        >
          <div>
            <div
              style={{
                textAlign: "center",
                fontWeight: "900",
                fontSize: "20px",
                minWidth: "20vw",
                marginBottom: "20px",
              }}
            >
              Select Booking
            </div>
            <div style={{ textAlign: "center" }}>
              {albumBookingData && Object.keys(albumBookingData)?.length > 0 ? (
                <div>
                  {Object.keys(albumBookingData)?.map((booking) => (
                    <div
                      key={booking}
                      className="bookingDiv"
                      onClick={() =>
                        printBooking(booking, albumBookingData[booking].work_id_list)
                      }
                    >
                      {albumBookingData[booking].title}
                    </div>
                  ))}
                </div>
              ) : (
                <div>No Bookings!</div>
              )}
            </div>
          </div>
        </Popup>
      )}

      {/* ===== Upload expiry information popup ===== */}
      {uploadExpiryOpen && (
        <Popup
          isOpen={uploadExpiryOpen}
          onClose={() => {
            setUploadExpiryOpen(false);
          }}
        >
          <div className="info_container">
            <h1 className="info_heading">Alert</h1>
            <p
              className="info_description"
              style={{ textAlign: "center", fontSize: "17px" }}
            >
              {expiryDate ? expiryDate : "Calculating..."}
            </p>
          </div>
        </Popup>
      )}

      {/* ===== Flag photo popup ===== */}
      {flagPhotoPopup && (
        <div className="infoDiv" style={{ zIndex: "201" }}>
          <div style={{ background: "white", padding: "20px", borderRadius: "5px" }}>
            <div style={{ padding: "7px 0 10px 0" }}>
              {" "}
              Do you want to {currentPhotoFlagged ? "unreport" : "report"} this pic.
            </div>
            <div style={{ textAlign: "right", padding: "7px 0 10px 0" }}>
              <button
                style={{
                  padding: "2px 5px",
                  borderRadius: "5px",
                  border: "1px solid black",
                  marginRight: "10px",
                }}
                onClick={() => {
                  setFlagPhotoPopup(false);
                }}
              >
                Cancel
              </button>
              <button
                style={{
                  padding: "2px 5px",
                  borderRadius: "5px",
                  background: get_platform_action_color(),
                  color: "white",
                  border: `1px solid ${get_platform_action_color()}`,
                }}
                onClick={() => {
                  handleFlagPhotos(galleryImages[photoIndex - 1]?.photo_id);
                  setFlagPhotoPopup(false);
                }}
              >
                {currentPhotoFlagged ? "Unreport" : "Report"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== Share selective popup ===== */}
      {shareSelective && (
        <div className="shareOverlay">
          <div className={`shareSelectiveDiv ${currentDimensions < 600 ? "drawer open" : ""}`}>
            <div
              style={{
                fontSize: "larger",
                fontWeight: "900",
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                padding: "10px 5%",
              }}
            >
              <div style={{ width: "16px" }}></div>
              <div>Share Selectively</div>
              <div>
                <FontAwesomeIcon
                  icon={faXmark}
                  size="lg"
                  onClick={confirShareLost}
                  style={{ cursor: "pointer" }}
                />
              </div>
            </div>
            <div
              style={{
                padding: "10px",
                display: "flex",
                justifyContent: "space-evenly",
                width: "100%",
                color: "white",
                background: get_platform_bg_color(),
              }}
            >
              {data?.data &&
                Object.keys(data?.data).map((key, index) => (
                  <React.Fragment key={index}>
                    {key === "photo-collection" && (
                      <div key={index}>
                        <div
                          onClick={() => switchShareTabs(photos)}
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            minWidth: "max-content",
                            padding: "10px 0",
                            margin: currentDimensions > 600 ? "0 20px" : "0 5px",
                            borderBottom: shareTab == photos && "3px solid white",
                            fontSize: currentDimensions < 600 && "13px",
                          }}
                        >
                          <div>
                            <img
                              style={{ height: "20px", paddingRight: "5px" }}
                              className="invert-image"
                              src={imageIcon}
                            />
                          </div>
                          <div>
                            <span style={{ paddingRight: "5px" }}>Photos</span>
                          </div>
                          {shareSelectList[photos]?.length > 0 && (
                            <div>{`(${shareSelectList[photos]?.length})`}</div>
                          )}
                        </div>
                      </div>
                    )}
                    {key === "video" && (
                      <div key={index}>
                        <div
                          onClick={() => switchShareTabs(videos)}
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            minWidth: "max-content",
                            padding: "10px 0",
                            margin: currentDimensions > 600 ? "0 20px" : "0 5px",
                            borderBottom: shareTab == videos && "3px solid white",
                            fontSize: currentDimensions < 600 && "13px",
                          }}
                        >
                          <div>
                            <img
                              style={{ height: "20px", paddingRight: "5px" }}
                              className="invert-image"
                              src={videoIcon}
                            />
                          </div>
                          <div>
                            <span style={{ paddingRight: "5px" }}>Videos</span>
                          </div>
                          {shareSelectList[videos]?.length > 0 && (
                            <div>{`(${shareSelectList[videos]?.length})`}</div>
                          )}
                        </div>
                      </div>
                    )}
                    {key === "album" && (
                      <div key={index}>
                        <div
                          onClick={() => switchShareTabs(albums)}
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            minWidth: "max-content",
                            padding: "10px 0",
                            margin: currentDimensions > 600 ? "0 20px" : "0 5px",
                            borderBottom: shareTab == albums && "3px solid white",
                            fontSize: currentDimensions < 600 && "13px",
                          }}
                        >
                          <div>
                            <img
                              style={{ height: "20px", paddingRight: "5px" }}
                              className="invert-image"
                              src={albumIcon}
                            />
                          </div>
                          <div>
                            <span style={{ paddingRight: "5px" }}>Albums</span>
                          </div>
                          {shareSelectList[albums]?.length > 0 && (
                            <div>{`(${shareSelectList[albums]?.length})`}</div>
                          )}
                        </div>
                      </div>
                    )}
                    {key === "folders" && (
                      <div key={index}>
                        <div
                          onClick={() => switchShareTabs(userFolders)}
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            minWidth: "max-content",
                            padding: "10px 0",
                            margin: currentDimensions > 600 ? "0 20px" : "0 5px",
                            borderBottom: shareTab == userFolders && "3px solid white",
                            fontSize: currentDimensions < 600 && "13px",
                          }}
                        >
                          <div>
                            <img
                              style={{ height: "20px", paddingRight: "5px" }}
                              className="invert-image"
                              src={libraryIcon}
                            />
                          </div>
                          <div>
                            <span style={{ paddingRight: "5px" }}>Library</span>
                          </div>
                          {shareSelectList[albums]?.length > 0 && (
                            <div>{`(${shareSelectList[albums]?.length})`}</div>
                          )}
                        </div>
                      </div>
                    )}
                  </React.Fragment>
                ))}
            </div>
            <div
              style={{
                textAlign: "right",
                padding: "0 24px",
                width: currentDimensions > 600 ? "100%" : "90%",
                display: "flex",
                justifyContent: "space-between",
                padding: "10px 5%",
              }}
            >
              {shareTab == photos && (
                <div>{checkPlurality(getShareTab(shareTab, data), "Collection")}</div>
              )}
              {shareTab == videos && (
                <div>{checkPlurality(getShareTab(shareTab, data), "Video")}</div>
              )}
              {shareTab == albums && (
                <div>{checkPlurality(getShareTab(shareTab, data), "Album")}</div>
              )}
              {getUnhiddenShareTab(shareTab, data, hiddenWork).length == (shareSelectList[shareTab]?.length) ? (
                <div
                  style={{ display: "flex", alignItems: "center" }}
                  onClick={() => shareSelectAllCollection(shareTab, [])}
                >
                  <FontAwesomeIcon
                    size="lg"
                    icon={faCircleCheck}
                    style={{
                      color: get_platform_action_color(),
                      backgroundColor: "white",
                      borderRadius: "50%",
                      paddingRight: "5px",
                    }}
                  />
                  <p>Select all</p>
                </div>
              ) : (
                <div
                  style={{ display: "flex", alignItems: "center" }}
                  onClick={() => shareSelectAllCollection(shareTab, getShareTab(shareTab, data))}
                >
                  <FontAwesomeIcon
                    size="lg"
                    icon={hollowCheck}
                    style={{
                      color: get_platform_action_color(),
                      backgroundColor: "white",
                      borderRadius: "50%",
                      paddingRight: "5px",
                    }}
                  />
                  <p>Select all</p>
                </div>
              )}
            </div>
            <div className="shareGrid">
              {getShareTab(shareTab, data).map((each) => {
                const canShare = tab == userFolders ? each.is_shareable : true;
                if (!canShare) return null;
                return (
                  <div
                    onClick={() => shareSelectMedia(shareTab, each.work_id)}
                    style={{
                      margin: "10px",
                      position: "relative",
                      maxWidth: currentDimensions > 600 ? "200px" : "150px",
                      minWidth: currentDimensions > 600 ? "200px" : "150px",
                      justifyItems: "center",
                      display: "grid",
                    }}
                    key={each.work_id}
                  >
                    <div className="shareCards">
                      <img
                        style={{
                          borderRadius: "10px",
                          height: "100%",
                          width: "100%",
                          objectFit: "cover",
                        }}
                        src={shareTab == videos ? each.thumb_url : each.cover_image}
                      />
                      <div
                        style={{
                          position: "absolute",
                          width: "100%",
                          height: "100%",
                          background: "rgba(0,0,0,0.5)",
                          top: "0",
                          borderRadius: "10px",
                        }}
                      ></div>
                    </div>
                    <div style={{ padding: "5px 0" }}>{each.title}</div>
                    {!hiddenWork[each.work_id] ? (
                      <div
                        style={{
                          position: "absolute",
                          top: "10px",
                          left: "20px",
                          cursor: "pointer",
                        }}
                      >
                        <div>
                          {shareSelectList && shareSelectList[shareTab]?.includes(each.work_id.toString()) ? (
                            <FontAwesomeIcon
                              size="lg"
                              icon={faCircleCheck}
                              style={{
                                color: get_platform_action_color(),
                                backgroundColor: "white",
                                borderRadius: "50%",
                              }}
                            />
                          ) : (
                            <FontAwesomeIcon
                              size="lg"
                              icon={hollowCheck}
                              style={{
                                color: get_platform_action_color(),
                                backgroundColor: "white",
                                borderRadius: "50%",
                              }}
                            />
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="hiddenShareCard">
                        <div className="hiddenShareCardText">Hidden media cannot be shared.</div>{" "}
                        <div className="unhideBtn" onClick={() => hideSelected(each.work_id, true)}>
                          Unhide
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
            <div style={{ textAlign: "right", padding: "15px 24px" }}>
              <button
                onClick={() => {
                  !isAdmin() && shareSelection();
                }}
                className="shareSelectiveDone"
                style={{ background: get_platform_action_color() }}
              >
                {`Share(${Object.values(shareSelectList).flat().length})`}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== Delete confirmation popup ===== */}
      {deletePopup && (
        <div className="infoDiv" style={{ zIndex: "201" }}>
          <div style={{ background: "white", padding: "20px", borderRadius: "5px" }}>
            {tab == "albumSelection" && (
              <div style={{ padding: "7px 0 10px 0" }}>
                Photos will be permanently deleted from this album!
              </div>
            )}
            {tab == "userFolders" && (
              <div style={{ padding: "7px 0 10px 0" }}>
                Photos will be permanently deleted from this collection!
              </div>
            )}
            {tab != "userFolders" && tab != "albumSelection" && (
              <div style={{ padding: "7px 0 10px 0" }}>Photos will be permanently deleted from this folder!</div>
            )}
            <div style={{ textAlign: "right", padding: "7px 0 10px 0" }}>
              <button
                style={{
                  padding: "2px 5px",
                  borderRadius: "5px",
                  border: "1px solid black",
                  marginRight: "10px",
                }}
                onClick={cancelSelection}
              >
                Cancel
              </button>
              <button
                style={{
                  padding: "2px 5px",
                  borderRadius: "5px",
                  background: get_platform_action_color(),
                  color: "white",
                  border: `1px solid ${get_platform_action_color()}`,
                }}
                onClick={() => {
                  setDeleteConfirm(true);
                  setDeletePopup(false);
                }}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== Trash delete popup ===== */}
      {trashDeletePopup && tab == userFolders && showTrash && (
        <div className="infoDiv" style={{ zIndex: "201" }}>
          <div style={{ background: "white", padding: "20px", borderRadius: "5px" }}>
            {tab == userFolders && showTrash &&
              (() => {
                const folder = trashFoldersInfo?.data?.folders?.find(
                  (f) => f.work_id === trashDeletePopup
                );
                const folderName = folder ? folder.title : "This folder";
                return (
                  <div style={{ padding: "7px 0 10px 0" }}>
                    <span style={{ fontWeight: "bold" }}>{folderName}</span> will be{" "}
                    <span style={{ fontWeight: "bold" }}>permanently</span> deleted
                  </div>
                );
              })()}
            <div style={{ textAlign: "right", padding: "7px 0 10px 0" }}>
              <button
                style={{
                  padding: "2px 5px",
                  borderRadius: "5px",
                  border: "1px solid black",
                  marginRight: "10px",
                }}
                onClick={() => {
                  setTrashDeletePopup(null);
                }}
              >
                Cancel
              </button>
              <button
                style={{
                  padding: "2px 5px",
                  borderRadius: "5px",
                  background: "#952d2d",
                  color: "white",
                  border: `1px solid #952d2d`,
                }}
                onClick={() => {
                  handleTrashDelete([trashDeletePopup]);
                  setTrashDeletePopup(null);
                }}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== All trash delete popup ===== */}
      {allTrashDeletePopup && tab == userFolders && showTrash && (
        <div className="infoDiv" style={{ zIndex: "201" }}>
          <div style={{ background: "white", padding: "20px", borderRadius: "5px" }}>
            {tab == userFolders && showTrash && (
              <div style={{ padding: "7px 0 10px 0" }}>
                All folder in the trash will be <span style={{ fontWeight: "bold" }}>permanently</span>{" "}
                deleted
              </div>
            )}
            <div style={{ textAlign: "right", padding: "7px 0 10px 0" }}>
              <button
                style={{
                  padding: "2px 5px",
                  borderRadius: "5px",
                  border: "1px solid black",
                  marginRight: "10px",
                }}
                onClick={() => {
                  setAllTrashDeletePopup(null);
                }}
              >
                Cancel
              </button>
              <button
                style={{
                  padding: "2px 5px",
                  borderRadius: "5px",
                  background: "#952d2d",
                  color: "white",
                  border: `1px solid #952d2d`,
                }}
                onClick={() => {
                  handleTrashDelete(
                    trashFoldersInfo?.data?.folders?.map((folder) => folder.work_id)
                  );
                  setAllTrashDeletePopup(false);
                }}
              >
                Delete All
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default WorkDetailPopup;


